<script setup>
import { computed, ref  } from 'vue';
import ContentFiltersSidebarWrapper from 'shared/components/contentLibrary/contentLibraryWrappers/contentFiltersSidebarWrapper.vue';
import ContentFiltersWrapper from 'shared/components/contentLibrary/contentLibraryWrappers/contentFiltersWrapper.vue';
import useProductList from 'shared/components/product/composables/useProductList.js';
import useContentLibrary from 'shared/components/contentLibrary/composables/useContentLibrary.js';

const props = defineProps({
	vm: Object
});

const vm = props.vm.BaseViewModel;

const displaySearch = computed(() =>
	productListComposable.value.displaySearchOnHero || contentLibraryComposable.value.displaySearchOnHero
);

const productListComposable = ref(null);
const contentLibraryComposable = ref(null);

productListComposable.value = useProductList();
contentLibraryComposable.value = useContentLibrary();

</script>

<template>
	<div
		v-if="displaySearch"
		class="hero-facet-wrapper"
		:class="{ reverse: vm.AlignMediaToTheLeft && vm.MediaList.length }"
		data-testid="hero-facet-wrapper"
	>
		<template v-if="contentLibraryComposable?.displaySearchOnHero">
			<ContentFiltersWrapper
				:contentLibraryComposable="contentLibraryComposable"
			/>
			<ContentFiltersSidebarWrapper
				:contentLibraryComposable="contentLibraryComposable"
			/>
		</template>
	</div>
</template>

<style lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

$margin-left: 84px;

.hero-search-wrapper {
	&.hide-on-desktop {
		display: none;
	}

	&.hide-on-mobile {
		display: flex;
	}

	&.no-media {
		margin-top: ds-space(8);
	}
}

.hero-facet-wrapper {
	.facet__list__deselect__wrapper,
	.c-content-filters {
		border: none;
		padding: 0;
		margin: ds-space(8) auto;
		position: relative;
		max-width: 1440px;
	}

	.facet__list__deselect__wrapper {
		margin: 0;
	}

	&.reverse .facet__list__deselect__wrapper,
	&.reverse .c-content-filters {
		justify-content: flex-end;
	}
}

// mobile styles
@include t-respond-to-max(ds-breakpoint('md')) {
	.hero-facet-wrapper {
		.facet__list__deselect__wrapper,
		.c-content-filters {
			margin-left: 0;
			padding-top: 0;
			padding-left: 0;
		}

		&.reverse .facet__list__deselect__wrapper,
		&.reverse .c-content-filters {
			margin-top: 0;
		}
	}

	.hero-search-wrapper {
		&.hide-on-desktop {
			display: flex;
		}

		&.hide-on-mobile {
			display: none;
		}
	}
}
</style>
